export default "__VITE_ASSET__5e32083b__"